import LogViewerGrid from '../components/Grid';
import { LogViewerProvider } from '../store';

export default function LogViewerGridLayout() {
  return <LogViewerProvider>
    <LogViewerGrid />
  </LogViewerProvider>;
}
